import { createFileRoute } from "@tanstack/react-router";
import { NotesPage } from "~/pages/NotesPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/notes/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Notes", link: `/${datasetSlug}/notes` }]);
  return <NotesPage />;
}
